<template>
  <date-range-picker
    ref="rangePicker"
    v-model="period"
    :locale-data="locale"
    :ranges="ranges"
    :date-format="dateFormat"
    :opens="opens"
    :class="['w-full sm:w-auto kompack-date-container', containerClass]"
    :control-container-class="controlContainerClass"
    @toggle="onToggle"
  >
    <template v-slot:input="picker">
      <slot
        name="default"
        :data="picker"
      >
        <div class="d-flex justify-between gap-[14px] items-center w-100 p-[3px]">
          <span :class="inputLabelClass">
            {{ getFormattedDateRange(picker.startDate, picker.endDate) }}
          </span>
          <span class="k-calendar text-[24px]" />
        </div>
      </slot>
    </template>
    <template v-slot:footer="footer">
      <slot
        name="footer"
        :data="footer"
      />
    </template>
  </date-range-picker>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { locale, ranges } from './config'
import { getFormattedDateRange } from './helpers'

/**
 * Date Range Picker component for Kompack
 * Provides a customizable date range selection interface
 * @component
 */
export default {
  components: {
    DateRangePicker,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    inputLabelClass: {
      type: String,
      default: 'text-[14px] text-[#c2c2c2]',
    },
    dateFormat: {
      type: Function,
      default: null,
    },
    ranges: {
      type: Object,
      default: () => ranges,
    },
    opens: {
      type: String,
      default: 'left',
    },
    containerClass: {
      type: String,
      default: '',
    },
    controlContainerClass: {
      type: String,
      default: 'form-control reportrange-text',
    },
  },
  data() {
    return {
      locale,
    }
  },
  computed: {
    period: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    getFormattedDateRange,
    onToggle(open) {
      this.$emit('toggle', open)
    },
    openPicker() {
      const picker = this.$refs.rangePicker
      if (picker && !picker.open) {
        picker.togglePicker(true, true)
      }
    },
    closePicker() {
      const picker = this.$refs.rangePicker
      if (picker && picker.open) {
        picker.togglePicker(false, true)
      }
    },
    togglePicker() {
      const picker = this.$refs.rangePicker
      if (picker) picker.togglePicker(null, true)
    },
  },
}
</script>

<style>
.kompack-date-container .form-control {
    border-color: #e2e2e2;
    border-radius: 8px;
}
</style>
